/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { affectedSiblingSchema } from './affectedSiblingSchema';

export const membershipOverridePreviewResponseSchema = z.object({
  get adjustedSyncedMemberships() {
    return z.array(affectedSiblingSchema);
  },
  membershipId: z.int(),
  proposedCommitment: z.number(),
  revertingToSource: z.boolean(),
});
